import { Component, input, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SourceEnum } from '../../../../shared/store/typeahead/types';
import { ContractService } from '../../../../shared/store/contract/contract.service';
import { ContractRejectReasonModel } from '../../../../shared/store/contract/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { FormService } from '../../../../shared/store/form/form.service';
import { setValidators } from '../../../../shared/helper/formhelper';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.ContractRejectReason)
@Component({
  selector: 'app-contract-reject-reason-content',
  templateUrl: './contract-reject-reason-content.component.html',
  styleUrls: ['./contract-reject-reason-content.component.scss'],
  standalone: false,
})
export class ContractRejectReasonContentComponent implements OnInit {
  @Input() modalRandomIdentifier: number;
  @Input() contractId: number;
  @Input() source: SourceEnum = SourceEnum.Component;
  rejectReasonMaxLength = input<number>();

  contractRejectReasonForm: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly contractService: ContractService,
    private readonly activeModalService: NgbActiveModal,
    private readonly subHeaderService: SubHeaderService,
    private readonly formService: FormService,
  ) {}

  ngOnInit(): void {
    this.contractRejectReasonForm = this.formBuilder.group({
      rejectReason: ['', [Validators.required]],
    });

    const rejectReasonMaxLength = this.rejectReasonMaxLength();
    if (rejectReasonMaxLength && rejectReasonMaxLength > 0) {
      setValidators(
        this.contractRejectReasonForm.get('rejectReason'),
        Validators.maxLength(rejectReasonMaxLength),
      );
    }

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'contractRejectReason') this.onSubmit();

        this.subHeaderService.setTriggerAction('');
      });
  }

  onSubmit() {
    if (this.contractRejectReasonForm.invalid) {
      this.contractRejectReasonForm.markAllAsTouched();
      this.formService.countErrors(this.contractRejectReasonForm, true);
      return;
    }

    const contractRejectReasonModel: ContractRejectReasonModel = {
      contractId: this.contractId,
      rejectReason: this.contractRejectReasonForm.get('rejectReason')?.value,
    };

    this.contractService.reject.call(contractRejectReasonModel);

    this.activeModalService.close();
  }
}
